import React from 'react';
import {Router, Route, Switch} from "react-router-dom";
import Home from './Pages/Home';
import LoadingMiddleware from './Pages/LoadingMiddelware/LoadingMiddelware';
import {history} from "./configs/history";

function App() {
  return (
      <Router history={history}>
        <Switch>
          <Route path='/app-loading' name='app loading' render={props => <LoadingMiddleware {...props}/>}/>
          <Route path='/' name='home' render={props => <Home {...props}/>}/>
        </Switch>
      </Router>
  );
}

export default App;
